(ns ycweb.app.website.dlp.widgets.brandsbox 
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]))

(rum/defc brands-box < rum/reactive [_ _ {:keys [properties]}]
  (let [brand-count (count (:brands properties))
        remainder (mod brand-count 4)
        bucket-size (/ brand-count 4)
        buckets
        (cond
          (= remainder 1)
          (partition-all (int bucket-size) (drop-last (:brands properties)))

          :else
          (partition-all (Math/ceil bucket-size) (:brands properties)))]
    [:<>
     [:div.yc-section
      (into
        [:div {:class (u/bem :flex-grid-group [:align-left])}]
        (for [brands buckets]
          [:div
           {:class
            (u/bem :flex-grid-block
              [:t-1-2 :ml-1-4])}
           [:div.flex-grid-content
            (into
              [:ul {:class (u/bem :yc-list [:small :flush])}]
              (for [brand brands]
                [:li
                 [:a
                  {:class (u/bem :text-link [:muted])
                   :href (:url brand)}
                  (:name brand)]]))]]))]]))
